/* @flow */

import Raven from 'raven-js';

export default function createMiddleware() {
  if (
    typeof Raven !== 'undefined' &&
    typeof Raven.captureException === 'function' &&
    Raven.isSetup()
  ) {
    return store => next => action => {
      const logger = console.error.bind(
        console,
        '[redux-raven-middleware] Reporting error to Sentry:'
      );

      try {
        Raven.captureBreadcrumb({
          category: 'redux',
          message: action.type,
        });

        return next(action);
      } catch (err) {
        logger(err);

        // Send the report.
        Raven.captureException(err, {
          extra: {
            action: typeof action === 'function' ? action.toString() : action,
            state: store.getState(),
          },
        });
      }
    };
  } else {
    return store => next => action => {
      next(action);
    };
  }
}



// WEBPACK FOOTER //
// ./src/raven/middleware.js